import React from 'react';
import { WrappedCard } from '../WrappedCard';
import type { WingoWrappedStats } from '../../../lib/wrapped/wrappedTypes';
import { format } from 'date-fns';
import { getDaisyCategory } from './DaisyCategoryCard';

interface ShareCardProps {
  stats: WingoWrappedStats;
  avatarUrl?: string;
  username?: string;
}

export const ShareCard: React.FC<ShareCardProps> = ({ stats, avatarUrl, username }) => {
  // Get DAISY Designation
  const daisyCategory = username ? getDaisyCategory(username) : null;
  
  return (
    <WrappedCard username={username}>
      <div className="space-y-3 md:space-y-4 bg-black/80 backdrop-blur-md p-4 md:p-5 rounded-3xl shadow-2xl w-full border-4 border-yellow-400/70">
        <div className="text-center">
          <h2 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-yellow-300 to-amber-200 bg-clip-text text-transparent mb-3 drop-shadow-2xl break-words">
            <div className="whitespace-nowrap">{stats.username}'s 2025</div>
            <div className="whitespace-nowrap">Wingo World Wapped</div>
          </h2>
          
          {/* Avatar */}
          {avatarUrl && (
            <div className="flex justify-center mb-3">
              <div className="relative w-20 h-20 md:w-24 md:h-24">
                <div className="absolute inset-0 bg-yellow-400 blur-2xl opacity-40"></div>
                <img
                  src={avatarUrl}
                  alt={`${stats.username}'s avatar`}
                  className="relative w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-4 border-yellow-400 shadow-xl"
                  style={{ objectPosition: 'center top' }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.src = '/avatars/default.png';
                  }}
                />
              </div>
            </div>
          )}
        </div>

        <div className="space-y-2 text-left bg-black/60 backdrop-blur-sm rounded-xl p-3 md:p-4 border-2 border-yellow-400/50">
          <div className="flex justify-between items-center gap-3 border-b-2 border-yellow-400/30 pb-2">
            <span className="text-yellow-300 font-semibold text-xs md:text-sm flex-shrink-0">Total Mined</span>
            <span className="font-bold text-yellow-200 text-xs md:text-sm text-right break-words">
              {stats.totalWingoMined.toLocaleString()} WINGO
            </span>
          </div>
          {stats.highestWingoSession && (
            <div className="flex justify-between items-center gap-3 border-b-2 border-yellow-400/30 pb-2">
              <span className="text-yellow-300 font-semibold text-xs md:text-sm flex-shrink-0">Top Session</span>
              <span className="font-bold text-yellow-200 text-xs md:text-sm text-right break-words">
                {stats.highestWingoSession.wingo.toLocaleString()} Wingos
              </span>
            </div>
          )}
          <div className="flex justify-between items-center gap-3 border-b-2 border-yellow-400/30 pb-2">
            <span className="text-yellow-300 font-semibold text-xs md:text-sm flex-shrink-0">DAISY Designation</span>
            <span className="font-bold text-yellow-200 text-xs md:text-sm text-right break-words">
              {daisyCategory ? daisyCategory.label : 'Come on Over'}
            </span>
          </div>
          {stats.votingShare !== undefined && (
            <div className="flex justify-between items-center gap-3 border-b-2 border-yellow-400/30 pb-2">
              <span className="text-yellow-300 font-semibold text-xs md:text-sm flex-shrink-0">Voting Share</span>
              <span className="font-bold text-yellow-200 text-xs md:text-sm text-right whitespace-nowrap">
                {stats.votingShare.toFixed(1)}%
              </span>
            </div>
          )}
          {stats.initiationDate && (
            <div className="flex justify-between items-center gap-3 pt-1">
              <span className="text-yellow-300 font-semibold text-xs md:text-sm flex-shrink-0">Initiation</span>
              <span className="font-bold text-yellow-200 text-xs md:text-sm text-right whitespace-nowrap">
                {format(stats.initiationDate, 'MMM yyyy')}
              </span>
            </div>
          )}
        </div>

        <div className="text-center text-xs text-yellow-300 font-bold mt-3 bg-yellow-500/20 backdrop-blur-sm rounded-lg py-1.5 border border-yellow-400/50">
          wingo320.com
        </div>
      </div>
    </WrappedCard>
  );
};

